import { useEffect, useRef, useState } from "react";
import { IPaginationV2 } from "../../../../Interfaces/base/ITable";
import { IUbicacionHazard } from "./UbicacionHazard";
import { ISearchBox } from "@fluentui/react";
import { IUbicacionCompletoDTO, IUbicacionRequest } from "../../../../Interfaces/auxiliar/IUbicacion";
import UbicacionService from "../../../../services/auxiliar/UbicacionService";

export const UseUbicacionHazard=(props:IUbicacionHazard)=>{
    const [loading, setLoading] = useState<boolean>(false);
    const onChangeSearch = useRef<ISearchBox>(null);
    const [items, setItems] = useState<IUbicacionCompletoDTO[]>([]);
    const [filter, setFilter] = useState<IUbicacionRequest>({
       skip: 0,
       take: 50,
       nivel: props.nivel
    });
 
    const initial: IUbicacionRequest = {
       skip: 0,
       take: 50,
       nivel: props.nivel
    };
 
    const _onkeyUpSearchTable = (
       event: React.KeyboardEvent<HTMLInputElement>
    ) => {
       let { value } = event?.target as HTMLInputElement;
       setFilter({ ...filter, search: value });
    };
 
    const onChangeTake = (value: number) => {
       setFilter({ ...filter, take: value })
    };
    const onSkip = (value: number) => {
       const realSkip = (value * filter.take) - filter.take
       setFilter({ ...filter, skip: realSkip })
    };
 
    const handleResetUpdate = () => {
       setFilter(initial);
    };
    const [pagination, setPagination] = useState<IPaginationV2>({
       currentPage: 0,
       total: 0,
       pageSize: 0,
       skip: 0,
       take: 50,
       onPageChange: function (value: number): void {
       },
       onSizeChange: function (value: number): void {
       }
    })
    const getUbicacion = () => {
        setLoading(true);
        UbicacionService.TablaUbicacionCompleto(filter)
           .then((res) => {
              const pag: IPaginationV2 = {
                 currentPage: res.data.page,
                 total: res.data.total,
                 pageSize: res.data.pages,
                 onPageChange: onSkip,
                 skip: filter.skip,
                 take: filter.take,
                 onSizeChange: onChangeTake
              };
              setPagination(pag);
              setLoading(false);
              setItems(res.data.items);
           })
           .catch((e: any) => {
              setLoading(false);
           });
     };
    useEffect(() => {
        if (filter) {
           getUbicacion();
        }
     }, [filter]);
  
     return {
        items,
        filter,
        setFilter,
        loading,
        pagination,
        handleResetUpdate,
        onChangeSearch,
        onChangeTake,
        _onkeyUpSearchTable
     };
}